<app-menu>
    <h1>Quote Details</h1>
    <div style="display: flex; justify-content: center;">
        <div class="container">
            <mat-card class="grid-item" id="general-info">
                <mat-card-header>
                    <mat-card-title>Details</mat-card-title>
                </mat-card-header>
                <br />
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Spot Quote ID</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.spot_quote_id || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Effective Date</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.effective_date || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Expiry Date</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.expiry_date || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Equipment Type</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.equipment_type || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Equipment Option</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.equipment_option || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Origin</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.origin_locality || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Destination</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.destination_locality || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Miles</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.distance_miles || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Order Scope</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.order_scope || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Load Weight</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.load_weight || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Shipment Type</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.shipment_type || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Shipment Quantity</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.shipment_type_quantity || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Created</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.created || "-"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Currency Type</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.currency_type || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Alternate Reference</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.alternate_reference || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Status</strong></div>
                                <div style="text-align: end;" class="table-cell">{{getStatus(details.spot_quote_status)}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Quoted By</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.quoted_by || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Sales Rep Name</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.sales_rep_name || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Partial or Full</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.partial_or_full || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Quote Contact Person</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.spot_quote_contact_person || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Load Start</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.load_start || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Load End</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.load_end || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Load Length</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.load_length || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Rate Method</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.rate_method || "-"}}</div>
                            </div>
                            <div class="table-row">
                                <div class="table-cell"><strong>Note</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.note || "-"}}</div>
                            </div>
                        </div>
                    </div>
                    <br />
                </mat-card-content>
            </mat-card>
            <mat-card class="grid-item">
                <mat-card-header>
                    <mat-card-title>Customer</mat-card-title>
                </mat-card-header>
                <br/>
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Organization</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_details.contact_organization || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Address Type</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_type || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Street Address</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_street || "-"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>City</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_locality || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Region</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_region || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Postal Code</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_postal_code || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Country</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_address_details.address_country || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Notes</strong></div>
                                <div style="text-align: end;" class="table-cell">{{customer_details.contact_note || "-"}}</div>
                            </div>
                        </div>
                    </div>
                    <br/>
                </mat-card-content>
            </mat-card>
            <mat-card class="grid-item">
                <mat-card-header>
                    <mat-card-title>Carrier</mat-card-title>
                </mat-card-header>
                <br/>
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Carrier Name</strong></div>
                                <div style="text-align: end;" class="table-cell">{{details.carrier_contact_organization || "Not assigned yet"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                        </div>
                    </div>
                    <br/>
                </mat-card-content>
            </mat-card>
            <mat-card class="grid-item">
                <mat-card-header>
                    <mat-card-title>Sales Rep (Internal Sales)</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>First Name</strong></div>
                                <div style="text-align: end;" class="table-cell">{{internal_sales_details.first_name || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Last Name</strong></div>
                                <div style="text-align: end;" class="table-cell">{{internal_sales_details.last_name || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Email Address</strong></div>
                                <div style="text-align: end;" class="table-cell">{{internal_sales_details.email_address || "-"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Phone Number</strong></div>
                                <div style="text-align: end;" class="table-cell">{{internal_sales_details.phone_number || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Notes</strong></div>
                                <div style="text-align: end;" class="table-cell">{{internal_sales_details.notes || "-"}}</div>
                            </div>
                        </div>
                    </div>
                    <br/>
                </mat-card-content>
            </mat-card>
            <mat-card class="grid-item">
                <mat-card-header>
                    <mat-card-title>Financial Chargeable</mat-card-title>
                </mat-card-header>
                <br/>
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Freight</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.freight_net_billable || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Rate Per Mile</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.chargeable_rate_per_mile || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Fuel Surcharge Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.fuel_surcharge_rate_billed || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Fuel Surcharge Plus Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.fuel_surcharge_plus_rate_billed || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Beyond</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.beyond_billed || "-"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Discount Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.discount_rate || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Discount</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.discount || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Tax Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.tax_rate_billed_multiplier || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Tax</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.billable_taxes || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Subtotal</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.gross_billed || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Total</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.total_charged || "-"}}</div>
                            </div>
                        </div>
                    </div>
                    <br/>
                </mat-card-content>
            </mat-card>
            <mat-card class="grid-item">
                <mat-card-header>
                    <mat-card-title>Financial Costs</mat-card-title>
                </mat-card-header>
                <br/>
                <mat-card-content>
                    <div class="table-container">
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Freight</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.freight_net_cost || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Rate Per Mile</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.cost_rate_per_mile || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Fuel Surcharge Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.fuel_surcharge_rate_cost || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Fuel Surcharge Plus Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.fuel_surcharge_plus_rate_cost || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Beyond</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.beyond_cost || "-"}}</div>
                            </div>
                        </div>
                        <div style="flex-basis: 48%;">
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Tax Rate</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.tax_rate_multiplier || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Tax</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.costs_taxed || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Subtotal</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.gross_costs || "-"}}</div>
                            </div>
                            <div style="border-top: 0.5px solid #ccc;" class="table-row">
                                <div class="table-cell"><strong>Total</strong></div>
                                <div style="text-align: end;" class="table-cell">{{financial_details.total_costs || "-"}}</div>
                            </div>
                        </div>
                    </div>
                    <br/>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <br><br>

</app-menu>